module.exports = __webpack_public_path__ + "images/green-nature-6-4aab859f31b364f7d4419298910c3c19.jpg";